import React, {useEffect, useState} from 'react';
import MixedSlider from "../accesories/slider/MixedSlider";
import AboutUs from "./AboutUs";
import OnlinePart from "./OnlinePart";
import OurServices from "./OurServices";
import TrustUs from "./TrustUs";
import OurProjects from "./OurProjects";
import Customers from "./Customers";
import OurEvents from "./OurEvents";
import OurBlog from "./OurBlog";
import WorkWithUs from "./WorkWithUs";
import OurTeam from "./OurTeam";
import apiRequest from "../../services/Axios/Configs/configs";
import {toast} from "react-toastify";
import {useData} from "../../context/DataContext";

function Home(props) {
    const[home,setHome]=useState({})
    const {data, fetchData, loading} = useData();

    const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;


    useEffect(() => {
        if (Array.isArray(data.home?.trust) && data.home.trust.length === 0) {
            fetchData("home", "");
        } else {
            setHome(data.home);
        }
    }, [data.home]);

    return (
        <>
            <MixedSlider/>
            {
                !isEmpty(home) &&
                <>
                    {home.site_settings &&
                        <AboutUs content={home.site_settings}/>
                    }
                    {home.Service?.length > 0 &&
                        <OurServices items={home.Service}/>
                    }

                    { !isEmpty(home.trust) &&
                        <TrustUs content={home.trust}/>
                    }

                    {home.projects?.length > 0 &&
                        <OurProjects projects={home.projects}/>
                    }

                    {home.comment?.length > 0 &&
                        <Customers comments={home.comment}/>
                    }
                    {home.events?.length > 0 &&
                        <OurEvents events={home.events}/>
                    }
                    {home.blogs?.length > 0 &&
                        <OurBlog blogs={home.blogs}/>
                    }

                    { home.site_settings?.collaboration_terms &&
                        <WorkWithUs content={home.site_settings.collaboration_terms} img={'images/work-with-us.jpg'}/>
                    }
                    {home.team?.length > 0 &&
                        <OurTeam header={'تیم '} span={'ما'} teamMembers={home.team}/>
                    }


                </>
            }

        </>
    );
}

export default Home;